import { render, staticRenderFns } from "./kvLabelInput.vue?vue&type=template&id=79a8268c&"
import script from "./kvLabelInput.vue?vue&type=script&lang=js&"
export * from "./kvLabelInput.vue?vue&type=script&lang=js&"
import style0 from "./kvLabelInput.vue?vue&type=style&index=0&id=79a8268c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a8268c')) {
      api.createRecord('79a8268c', component.options)
    } else {
      api.reload('79a8268c', component.options)
    }
    module.hot.accept("./kvLabelInput.vue?vue&type=template&id=79a8268c&", function () {
      api.rerender('79a8268c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/input/kvLabelInput.vue"
export default component.exports